import React from "react"
export function UpArrow(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M2 9.131l7.446-6.916a.821.821 0 011.01-.077l.098.077L18 9.131l-1.108 1.106-6.106-5.67.02 13.43L9.21 18 9.19 4.586l-6.082 5.65L2 9.132z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__up-arrow"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
